module.exports = __webpack_public_path__ + "img/img2.7efbb69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img2.jpg
// module id = 316
// module chunks = 0